module.exports = __webpack_public_path__ + "static/media/Search.29480ae7.svg";